import Message from 'shared_components/message';
import { axiosPhase2API, axiosLabAPI } from 'services/axios';
import HttpCodeMessage from 'shared_components/message_http_status';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchWardAndRoomsItems() {
	let WardAndRoomsItems = [];

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: `settings/hospitallocation`,
		});

		const { data } = response;
		WardAndRoomsItems = data.RECORDS;
	} catch (e) {
		showMessage(e);
	}

	return WardAndRoomsItems;
}

export async function createWardAndRoomsItems(payload) {
	let createdWardAndRooms;
	const { name, department, integrationCode, locationTypeID, is_active } = payload;
	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			url: `settings/hospitallocation`,
			data: {
				p_location_name: name,
				p_department: department,
				p_integration_code: integrationCode,
				p_location_type_id: locationTypeID,
				p_active: is_active
			},
		});
		const { data } = response;
		createdWardAndRooms = data;
	} catch (e) {
		showMessage(e);
	}
	return createdWardAndRooms;
}

export async function updateWardAndRoomsItems(payload) {
	let updatedWardAndRooms;
	const { locationID, name, department, integrationCode, locationTypeID, is_active } = payload;

	try {
		const content = {
			method: API_PUT_METHOD,
			url: `settings/hospitallocation`,
			data: {
				p_location_id: locationID,
				p_location_name: name,
				p_department: department,
				p_integration_code: integrationCode,
				p_location_type_id: locationTypeID,
				p_active: is_active
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		updatedWardAndRooms = data;
	} catch (e) {
		showMessage(e);
	}

	return updatedWardAndRooms;
}

export async function applySorting(payload) {
	let sortResponse;
	const url = `settings/hospitallocationsorting`;

	try {
		const content = {
			method: API_PUT_METHOD,
			url,
			data: {
				p_location_sorting_array: JSON.stringify(payload)
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		sortResponse = data;

		// Show success message from API response
		if (data && data.STATUSCODE === 200 && data.MESSAGE) {
			Message.success({ message: data.MESSAGE });
		}
	} catch (error) {
		showMessage(error);
	}

	return sortResponse;
}
